import type { ReactElement } from 'react'

import AlgoliaClearRefinements from '~/components/Algolia/ClearRefinements'
import AlgoliaRefinementList from '~/components/Algolia/RefinementList'

const IapInputFilters = (): ReactElement => {
  return (
    <div className="iap-input-filters">
      <AlgoliaClearRefinements />
      <div>
        <AlgoliaRefinementList attribute="price" label="Price" />
      </div>
      <div>
        <AlgoliaRefinementList attribute="status" label="Status" />
      </div>
      <div>
        <AlgoliaRefinementList attribute="subscription_period" label="Subscription period" />
      </div>
      <div>
        <AlgoliaRefinementList attribute="trial_period" label="Trial period" />
      </div>
    </div>
  )
}

export default IapInputFilters
